(function(){
  var T={
    it:{sub:'ATELIER SU APPUNTAMENTO \u2014 FISICO E VIRTUALE PRIVATO',motto:'Discrezione. Materia. Luce.',d:'Da oltre 30 anni trasformo le vostre idee in gioielli che durano una vita'},
    fr:{sub:'ATELIER SUR RENDEZ-VOUS \u2014 PHYSIQUE ET VIRTUEL',motto:'Discr\u00e9tion. Mati\u00e8re. Lumi\u00e8re.',d:'Depuis plus de 30 ans je transforme vos id\u00e9es en bijoux qui durent toute une vie'},
    nl:{sub:'ATELIER OP AFSPRAAK \u2014 FYSIEK EN VIRTUEEL',motto:'Discretie. Materie. Licht.',d:'Al meer dan 30 jaar verander ik uw idee\u00ebn in sieraden die een leven lang meegaan'},
    en:{sub:'ATELIER BY APPOINTMENT \u2014 PHYSICAL AND VIRTUAL',motto:'Discretion. Matter. Light.',d:'For over 30 years I have been turning your ideas into jewellery that lasts a lifetime'}
  };
  window.setLang=function(l){
    var d=T[l];if(!d)return;
    var es=document.getElementById('t-sub');if(es)es.textContent=d.sub;
    var em=document.getElementById('t-motto');if(em)em.textContent=d.motto;
    var ed=document.getElementById('t-d');if(ed)ed.textContent=d.d;
    ['it','fr','nl','en'].forEach(function(x){
      var b=document.getElementById('btn-'+x);if(!b)return;
      if(x===l){b.style.background='#C9A86A';b.style.color='#000';b.style.borderColor='#C9A86A';b.style.fontWeight='700';}
      else{b.style.background='transparent';b.style.color='#888';b.style.borderColor='#444';b.style.fontWeight='400';}
    });
    localStorage.setItem('tg-lang',l);
  };
  document.addEventListener('DOMContentLoaded',function(){
    window.setLang(localStorage.getItem('tg-lang')||'it');
  });
})();